import { NewFeaturedDocumentRequest } from "./";

export class ModifyFeaturedDocumentRequest {
  featuredDocuments: NewFeaturedDocumentRequest[];

  constructor(featuredDocuments?: NewFeaturedDocumentRequest[]) {
    this.featuredDocuments = featuredDocuments || [];
  }
}
